import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { CsHttpClientService } from '@cbuild/cs-common-data-services';
import { UserAvailabilityStatus } from '@cbuild/enums';
import { finalize, take } from 'rxjs';
import { UserInfo } from '../../models/user-info.model';
import { BaseUrlService } from '../../services/base-url.service';

@Component({
  selector: 'cs-call-center-status',
  standalone: false,
  templateUrl: './call-center-status.component.html',
  styleUrls: ['./call-center-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CallCenterStatusComponent implements OnInit {
  public status: number | null;
  public availabilityStatus = UserAvailabilityStatus;
  @Input()
  public userInfo: UserInfo;
  public viewClasses: {
    'status-active': boolean;
    'status-break': boolean;
    'status-leave': boolean;
    'no-call-center': boolean;
  };
  private dataSent: boolean;

  private getOrUpdateResponseHandle = (
    _: Array<{ availableStatus: number | null }>
  ) => {
    this.status = _[0].availableStatus;
    this.updateView();
    this.cdr.markForCheck();
  };

  constructor(
    private http: CsHttpClientService,
    private baseURL: BaseUrlService,
    private cdr: ChangeDetectorRef
  ) {
    this.updateView();
  }

  public ngOnInit(): void {
    setTimeout(() => {
      this.checkStatus();
    }, 2500);
  }

  private checkStatus(): void {
    this.http
      .read<Array<{ availableStatus: number | null }>>(
        'api/account/query/user/status',
        this.baseURL.getApiBaseURL()
      )
      .pipe(take(1))
      .subscribe(this.getOrUpdateResponseHandle);
  }

  private updateView(): void {
    this.viewClasses = {
      'status-active': this.status === 1,
      'status-break': this.status === 2,
      'status-leave': this.status === 3,
      'no-call-center': !this.status
    };
  }

  public updateStatusWith(updatedStatus: number): void {
    if (updatedStatus !== this.status && !this.dataSent) {
      const data = { status: updatedStatus, uid: this.userInfo.userId };
      this.dataSent = true;
      this.http
        .writeText<Array<{ availableStatus: number | null }>>(
          'api/account/update/user/status',
          data,
          this.baseURL.getApiBaseURL()
        )
        .pipe(
          take(1),
          finalize(() => {
            this.dataSent = false;
          })
        )
        .subscribe(this.getOrUpdateResponseHandle);
    }
  }
}
